import UsersRequest from "../ws/UsersRequest";

export const USERS_AUTOCOMPLETE_UPDATE = 'users-autocomplete-update';
export const USERS_AUTOCOMPLETE_LOADING = 'users-autocomplete-loading';

export const getUsers = (id, search = '', onlyActive = false) => (dispatch) => {

  new UsersRequest(0, search)
    .onPreExecution(() => {
      dispatch({
        type: USERS_AUTOCOMPLETE_LOADING,
        id: id,
        payload: true,
      });
    })
    .onSuccess(response => {
      // Enviamos los datos a redux
      dispatch({
        type: USERS_AUTOCOMPLETE_UPDATE,
        id: id,
        payload: response,
      });
    })
    .onPostExecution(() => {
      dispatch({
        type: USERS_AUTOCOMPLETE_LOADING,
        id: id,
        payload: false,
      });
    })
    .execute();
};



// WEBPACK FOOTER //
// ./src/app/users/actions/userAutocompleteActions.js